import { formatTraffic, TRAFFIC_STEPS } from '@/state/onboarding/plan-model';

type TrafficSliderProps = { value: number; onChange: (index: number) => void };

/** "Sessions a month on your site": picks the plan that fits. */
export const TrafficSlider = ({ value, onChange }: TrafficSliderProps) => (
  <div className="flex min-w-0 flex-[1_1_340px] flex-col gap-[7px]">
    <div className="flex items-baseline justify-between gap-3">
      <label htmlFor="traffic" className="micro-label">
        Sessions a month on your site
      </label>
      <span className="text-accent font-mono text-[13px] font-medium">{formatTraffic(value)}</span>
    </div>
    <div className="border-line bg-field flex h-11 items-center rounded-lg border px-[13px]">
      <input
        id="traffic"
        type="range"
        min={0}
        max={TRAFFIC_STEPS.length - 1}
        step={1}
        value={value}
        onChange={(ev) => onChange(Number(ev.target.value))}
        className="m-0 w-full"
        style={{ accentColor: 'hsl(var(--accent))' }}
      />
    </div>
    <span className="text-dim text-nano leading-snug">
      The plan that fits is marked below. Not sure? Start small and upgrade from Settings.
    </span>
  </div>
);
